var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-time"},[_vm._v(_vm._s(_vm.duration > 0 ? _vm.time : '视频'))])
}
var staticRenderFns = []

export { render, staticRenderFns }